const moment = require('moment')
export default {
  singOut (state) {
    state.autenticacao.autenticado = false
    document.cookie = 'tokenValidade=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/'
    document.cookie = 'tokenAcesso=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/'
    document.cookie = 'tokenNivel=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/'
    document.cookie = 'tokenNome=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/'
    document.cookie = 'tokenStatus=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/'
  },
  singIn (state, payload) {
    state.usuario.login = ''
    state.usuario.senha = ''
    state.autenticacao.autenticado = true
    state.autenticacao.status = parseInt(payload.status)
    state.autenticacao.nivel = parseInt(payload.nivel)
    state.autenticacao.token = payload.token
    state.autenticacao.nome = payload.nome
    window.axios(state.autenticacao.token)
  },
  createSession (state, payload) {
    let d
    if (payload.time === false) {
      d = moment().add(1, 'y')
    } else {
      d = moment().add(payload.time, 'm')
    }
    let expires = d.format()
    // d.setTime(d.getTime() + 1000 * 60 * 1000)
    document.cookie = 'tokenValidade=' + expires + ';expires=' + expires + '; path=/'
    document.cookie = 'tokenAcesso=' + payload.token + ';expires=' + expires + '; path=/'
    document.cookie = 'tokenNivel=' + payload.nivel + ';expires=' + expires + '; path=/'
    document.cookie = 'tokenNome=' + payload.nome + ';expires=' + expires + '; path=/'
    document.cookie = 'tokenStatus=' + payload.status + ';expires=' + expires + '; path=/'
  },
  updatePersistencia (state, value) {
    state.usuario.persistencia = value
  },
  updateLogin (state, value) {
    state.usuario.login = value
  },
  updateSenha (state, value) {
    state.usuario.senha = value
  },
  loadingAutenticacao (state, value) {
    state.loading = value
  },
  updateStatus (state, value) {
    state.autenticacao.status = value
  }
}



// WEBPACK FOOTER //
// ./src/store/autenticacao/mutations.js